
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexYM3bxO2kQgUP4qrrb0nIiAtJnChqj2GaZrKxmD2ocgoMeta } from "/home/runner/work/jadoo/jadoo/pages/index.vue?macro=true";
import { default as index0DlrRSoPbvvzQv2f7RGfItrYzA1r19_m_45sWFo1t8w_45sMeta } from "/home/runner/work/jadoo/jadoo/pages/auth/index.vue?macro=true";
import { default as indexsFiDgB5qrK1_QuPLkDgaeDgMWGmbaUeBRaoM_WrYuR0Meta } from "/home/runner/work/jadoo/jadoo/pages/data/index.vue?macro=true";
import { default as failB3QgdUfPakkd3yUzDqcHDfL44eMKNSVD_45bWKfnIIPqsMeta } from "/home/runner/work/jadoo/jadoo/pages/point/fail.vue?macro=true";
import { default as list9c4XkeMtwDMkZcTWcj8IJISfZx7F7kgskcWoNEFC0wUMeta } from "/home/runner/work/jadoo/jadoo/pages/point/list.vue?macro=true";
import { default as index4lvwPdGIH_IftUCsbxrFWa_bSUuT5w_45MpSKYSG7u054Meta } from "/home/runner/work/jadoo/jadoo/pages/login/index.vue?macro=true";
import { default as errorcKEccYUV1am_45U6hFJ9gcA9Cqsdp4zkW2kpudEbvAyuUMeta } from "/home/runner/work/jadoo/jadoo/pages/point/error.vue?macro=true";
import { default as indexWoCOqr_dKH45OofaV0_45oQUBB_45hEVWGfpv4GpG8gnXuIMeta } from "/home/runner/work/jadoo/jadoo/pages/quick/index.vue?macro=true";
import { default as _91token_93awGSOpWn_45_45zmULzkp8vA186XYe8G_NmUWDbdnUeRA3YMeta } from "/home/runner/work/jadoo/jadoo/pages/auth/[token].vue?macro=true";
import { default as chargecAx9tWHEnMr_MvNcPjeOI95TJoN7krVpkBDLtZ6i_dkMeta } from "/home/runner/work/jadoo/jadoo/pages/point/charge.vue?macro=true";
import { default as index5cfWJGJzcIsDbNoF79OI9YiO59IIqhfuAE11VGERQ00Meta } from "/home/runner/work/jadoo/jadoo/pages/signup/index.vue?macro=true";
import { default as processiWLoeDRY37zeSRDSOSv6bkAk_453YRS_K_45IozwBMOaDdsMeta } from "/home/runner/work/jadoo/jadoo/pages/point/process.vue?macro=true";
import { default as success551Nm1FQgEXkciVJ9lStpIy2sYsnMDu8Zag4cjk0uwMMeta } from "/home/runner/work/jadoo/jadoo/pages/point/success.vue?macro=true";
import { default as passage4s4l5fP7LYHt2gXj4P38RZUGtyPQjtjq6TXnUPoIphkMeta } from "/home/runner/work/jadoo/jadoo/pages/print/passage.vue?macro=true";
import { default as preview9uM6sK_Duxmgr0Z4pDsLZEaQi5ch_45m5YYjjFAJx7fdIMeta } from "/home/runner/work/jadoo/jadoo/pages/print/preview.vue?macro=true";
import { default as editIl_oB_Wxdhz0hj_45LWEZOzMNWes08Z1FT_5ufZ73umuAMeta } from "/home/runner/work/jadoo/jadoo/pages/userinfo/edit.vue?macro=true";
import { default as categoryQKYHUeXug0mTvBFb15Uv8EzHUtk2ykgQ6MGXJE5AdmgMeta } from "/home/runner/work/jadoo/jadoo/pages/print/category.vue?macro=true";
import { default as indexM690f46ccmVmtEqsksPRpWVmrCcpfAsOmszGrT7z7DAMeta } from "/home/runner/work/jadoo/jadoo/pages/userinfo/index.vue?macro=true";
import { default as index7vcgrGoLmgApmSlrIrFo5s03S2fU_45ekIAOWAIFdpug8Meta } from "/home/runner/work/jadoo/jadoo/pages/myStorage/index.vue?macro=true";
import { default as indexh6NkI0RsMUGXG9sVAzEmVn0aoryrHOfLCJ2UXw7CZbwMeta } from "/home/runner/work/jadoo/jadoo/pages/data/basic/index.vue?macro=true";
import { default as naverPZrkbmzzomUdgfkwhKy6F0_Lz_45mFSTuVXp9hgb4dmscMeta } from "/home/runner/work/jadoo/jadoo/pages/test/oauth/naver.vue?macro=true";
import { default as googleEpjib35_45tEXNudPoeUmZYGUEE2ccrvgrvcanNECq8IIMeta } from "/home/runner/work/jadoo/jadoo/pages/test/oauth/google.vue?macro=true";
import { default as _91ed_idx_936Zhi6f1K1XTqRQVHVNnXPT6WQTGbK8tXTw_452m_D4ctIMeta } from "/home/runner/work/jadoo/jadoo/pages/myStorage/[ed_idx].vue?macro=true";
import { default as process_45fail_45nUJzMmFtYfxvScvlHkhOQndKnDokzBhdHFrj1goVRoMeta } from "/home/runner/work/jadoo/jadoo/pages/point/process-fail.vue?macro=true";
import { default as navertcZ7PRMfa_bwTACvjhl7nfBSILd6jJfyqi0E7K18aZ8Meta } from "/home/runner/work/jadoo/jadoo/pages/auth/callback/naver.vue?macro=true";
import { default as indexIIoS3sLLpOB_450rHeL0sRFe3NFziyOzlTLu9vQmPo1skMeta } from "/home/runner/work/jadoo/jadoo/pages/data/advanced/index.vue?macro=true";
import { default as sentry_45example_45pageRFk1uSQNPaW3FWFyebfIjRf9oLxILLBxeHAP7p1gBdEMeta } from "/home/runner/work/jadoo/jadoo/pages/sentry-example-page.vue?macro=true";
import { default as google3nczgKuRuNPulEee0bBHOPV3lDx_Vc6tgZmInBfGMKkMeta } from "/home/runner/work/jadoo/jadoo/pages/auth/callback/google.vue?macro=true";
import { default as index7ey5QpvWLiDxRlnvbSZzAHCCPxgQEfgzISU_h9SVOwEMeta } from "/home/runner/work/jadoo/jadoo/pages/data/transform/index.vue?macro=true";
import { default as _91idx_93P9gavM_45fFZ3aUnncbDWbNg_457D6bHQEYXlXiLAQel_45VAMeta } from "/home/runner/work/jadoo/jadoo/pages/passageStorage/[idx].vue?macro=true";
import { default as indexpKAbZQW8mhTwROma0wp388oPDcQxrFz8Pwbq8codAnkMeta } from "/home/runner/work/jadoo/jadoo/pages/passageStorage/index.vue?macro=true";
import { default as listtEJJ0ebuAVuUmSnfYOQPrxhBtbDLjWY0F9OlOFOaLTwMeta } from "/home/runner/work/jadoo/jadoo/pages/personalInquiry/list.vue?macro=true";
import { default as indexuxiX3_45AVz28r_45WFOMu7vXIkDdSUYKLcGTVyG7rKqXs8Meta } from "/home/runner/work/jadoo/jadoo/pages/event/promotion/index.vue?macro=true";
import { default as inquiryYzrqgzwBRDAGTdsSqkv_45kAyl9_45VrqMXYNHjD5Ubb67kMeta } from "/home/runner/work/jadoo/jadoo/pages/personalInquiry/inquiry.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: { ...(indexYM3bxO2kQgUP4qrrb0nIiAtJnChqj2GaZrKxmD2ocgoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/jadoo/jadoo/pages/index.vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: index0DlrRSoPbvvzQv2f7RGfItrYzA1r19_m_45sWFo1t8w_45sMeta || {},
    component: () => import("/home/runner/work/jadoo/jadoo/pages/auth/index.vue")
  },
  {
    name: "data",
    path: "/data",
    meta: { ...(indexsFiDgB5qrK1_QuPLkDgaeDgMWGmbaUeBRaoM_WrYuR0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/jadoo/jadoo/pages/data/index.vue")
  },
  {
    name: "point-fail",
    path: "/point/fail",
    meta: { ...(failB3QgdUfPakkd3yUzDqcHDfL44eMKNSVD_45bWKfnIIPqsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/jadoo/jadoo/pages/point/fail.vue")
  },
  {
    name: "point-list",
    path: "/point/list",
    meta: { ...(list9c4XkeMtwDMkZcTWcj8IJISfZx7F7kgskcWoNEFC0wUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/jadoo/jadoo/pages/point/list.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(index4lvwPdGIH_IftUCsbxrFWa_bSUuT5w_45MpSKYSG7u054Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/jadoo/jadoo/pages/login/index.vue")
  },
  {
    name: "point-error",
    path: "/point/error",
    meta: { ...(errorcKEccYUV1am_45U6hFJ9gcA9Cqsdp4zkW2kpudEbvAyuUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/jadoo/jadoo/pages/point/error.vue")
  },
  {
    name: "quick",
    path: "/quick",
    meta: { ...(indexWoCOqr_dKH45OofaV0_45oQUBB_45hEVWGfpv4GpG8gnXuIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/jadoo/jadoo/pages/quick/index.vue")
  },
  {
    name: "auth-token",
    path: "/auth/:token()",
    meta: _91token_93awGSOpWn_45_45zmULzkp8vA186XYe8G_NmUWDbdnUeRA3YMeta || {},
    component: () => import("/home/runner/work/jadoo/jadoo/pages/auth/[token].vue")
  },
  {
    name: "point-charge",
    path: "/point/charge",
    meta: { ...(chargecAx9tWHEnMr_MvNcPjeOI95TJoN7krVpkBDLtZ6i_dkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/jadoo/jadoo/pages/point/charge.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: index5cfWJGJzcIsDbNoF79OI9YiO59IIqhfuAE11VGERQ00Meta || {},
    component: () => import("/home/runner/work/jadoo/jadoo/pages/signup/index.vue")
  },
  {
    name: "point-process",
    path: "/point/process",
    meta: { ...(processiWLoeDRY37zeSRDSOSv6bkAk_453YRS_K_45IozwBMOaDdsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/jadoo/jadoo/pages/point/process.vue")
  },
  {
    name: "point-success",
    path: "/point/success",
    meta: { ...(success551Nm1FQgEXkciVJ9lStpIy2sYsnMDu8Zag4cjk0uwMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/jadoo/jadoo/pages/point/success.vue")
  },
  {
    name: "print-passage",
    path: "/print/passage",
    meta: passage4s4l5fP7LYHt2gXj4P38RZUGtyPQjtjq6TXnUPoIphkMeta || {},
    component: () => import("/home/runner/work/jadoo/jadoo/pages/print/passage.vue")
  },
  {
    name: "print-preview",
    path: "/print/preview",
    meta: preview9uM6sK_Duxmgr0Z4pDsLZEaQi5ch_45m5YYjjFAJx7fdIMeta || {},
    component: () => import("/home/runner/work/jadoo/jadoo/pages/print/preview.vue")
  },
  {
    name: "userinfo-edit",
    path: "/userinfo/edit",
    meta: { ...(editIl_oB_Wxdhz0hj_45LWEZOzMNWes08Z1FT_5ufZ73umuAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/jadoo/jadoo/pages/userinfo/edit.vue")
  },
  {
    name: "print-category",
    path: "/print/category",
    meta: categoryQKYHUeXug0mTvBFb15Uv8EzHUtk2ykgQ6MGXJE5AdmgMeta || {},
    component: () => import("/home/runner/work/jadoo/jadoo/pages/print/category.vue")
  },
  {
    name: "userinfo",
    path: "/userinfo",
    meta: { ...(indexM690f46ccmVmtEqsksPRpWVmrCcpfAsOmszGrT7z7DAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/jadoo/jadoo/pages/userinfo/index.vue")
  },
  {
    name: "myStorage",
    path: "/myStorage",
    meta: { ...(index7vcgrGoLmgApmSlrIrFo5s03S2fU_45ekIAOWAIFdpug8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/jadoo/jadoo/pages/myStorage/index.vue")
  },
  {
    name: "data-basic",
    path: "/data/basic",
    meta: { ...(indexh6NkI0RsMUGXG9sVAzEmVn0aoryrHOfLCJ2UXw7CZbwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/jadoo/jadoo/pages/data/basic/index.vue")
  },
  {
    name: "test-oauth-naver",
    path: "/test/oauth/naver",
    component: () => import("/home/runner/work/jadoo/jadoo/pages/test/oauth/naver.vue")
  },
  {
    name: "test-oauth-google",
    path: "/test/oauth/google",
    component: () => import("/home/runner/work/jadoo/jadoo/pages/test/oauth/google.vue")
  },
  {
    name: "myStorage-ed_idx",
    path: "/myStorage/:ed_idx()",
    meta: { ...(_91ed_idx_936Zhi6f1K1XTqRQVHVNnXPT6WQTGbK8tXTw_452m_D4ctIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/jadoo/jadoo/pages/myStorage/[ed_idx].vue")
  },
  {
    name: "point-process-fail",
    path: "/point/process-fail",
    component: () => import("/home/runner/work/jadoo/jadoo/pages/point/process-fail.vue")
  },
  {
    name: "auth-callback-naver",
    path: "/auth/callback/naver",
    meta: navertcZ7PRMfa_bwTACvjhl7nfBSILd6jJfyqi0E7K18aZ8Meta || {},
    component: () => import("/home/runner/work/jadoo/jadoo/pages/auth/callback/naver.vue")
  },
  {
    name: "data-advanced",
    path: "/data/advanced",
    meta: { ...(indexIIoS3sLLpOB_450rHeL0sRFe3NFziyOzlTLu9vQmPo1skMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/jadoo/jadoo/pages/data/advanced/index.vue")
  },
  {
    name: "sentry-example-page",
    path: "/sentry-example-page",
    component: () => import("/home/runner/work/jadoo/jadoo/pages/sentry-example-page.vue")
  },
  {
    name: "auth-callback-google",
    path: "/auth/callback/google",
    meta: google3nczgKuRuNPulEee0bBHOPV3lDx_Vc6tgZmInBfGMKkMeta || {},
    component: () => import("/home/runner/work/jadoo/jadoo/pages/auth/callback/google.vue")
  },
  {
    name: "data-transform",
    path: "/data/transform",
    meta: { ...(index7ey5QpvWLiDxRlnvbSZzAHCCPxgQEfgzISU_h9SVOwEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/jadoo/jadoo/pages/data/transform/index.vue")
  },
  {
    name: "passageStorage-idx",
    path: "/passageStorage/:idx()",
    meta: { ...(_91idx_93P9gavM_45fFZ3aUnncbDWbNg_457D6bHQEYXlXiLAQel_45VAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/jadoo/jadoo/pages/passageStorage/[idx].vue")
  },
  {
    name: "passageStorage",
    path: "/passageStorage",
    meta: { ...(indexpKAbZQW8mhTwROma0wp388oPDcQxrFz8Pwbq8codAnkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/jadoo/jadoo/pages/passageStorage/index.vue")
  },
  {
    name: "personalInquiry-list",
    path: "/personalInquiry/list",
    meta: { ...(listtEJJ0ebuAVuUmSnfYOQPrxhBtbDLjWY0F9OlOFOaLTwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/jadoo/jadoo/pages/personalInquiry/list.vue")
  },
  {
    name: "event-promotion",
    path: "/event/promotion",
    meta: indexuxiX3_45AVz28r_45WFOMu7vXIkDdSUYKLcGTVyG7rKqXs8Meta || {},
    component: () => import("/home/runner/work/jadoo/jadoo/pages/event/promotion/index.vue")
  },
  {
    name: "personalInquiry-inquiry",
    path: "/personalInquiry/inquiry",
    meta: { ...(inquiryYzrqgzwBRDAGTdsSqkv_45kAyl9_45VrqMXYNHjD5Ubb67kMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/jadoo/jadoo/pages/personalInquiry/inquiry.vue")
  }
]